import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import { apiFetch } from "@/hooks/apiFetch"
import { toast } from "sonner"
import Modal from "./Model"
import { useState } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { isAdminPortal } from "@/utilities/domain"
import {
  ReportBranchFilter,
  ReportBranchProvider,
  useReportBranch,
  withBranchColumn,
} from "@/components/Reports/ReportBranchFilter"

const adminColumns = withBranchColumn(columns)

export default function StockAdjustmentList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Stock Adjustment</h5>
      </div>

      {isAdminPortal() ? (
        <ReportBranchProvider>
          <AdminStockAdjustmentTable />
        </ReportBranchProvider>
      ) : (
        <CrudProvider>
          <StockAdjustmentTable />
        </CrudProvider>
      )}
    </>
  )
}

function StockAdjustmentTable() {
  const { openDialog, setOpenDialog, setSelectedRow } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Stock Adjustment"
        columns={columns}
        apiPath="stock-adjustments"
        onEdit={async (rowData) => {
          try {
            const adjustment = await apiFetch(`stock-adjustments/${rowData.id}`)
            setSelectedRow(adjustment.data)
            setOpenDialog(true)
          } catch (error) {
            toast.error(error.message)
          }
        }}
      />

      {openDialog ? <Modal /> : null}
    </>
  )
}

// Company administrators review every branch's adjustments, or a selected
// one; stock is adjusted on the branch portals.
function AdminStockAdjustmentTable() {
  const { branchId } = useReportBranch()
  const branchFilter = React.useMemo(
    () => ({ branch_id: branchId }),
    [branchId]
  )

  return (
    <CustomTable
      label="Stock Adjustment"
      columns={adminColumns}
      apiPath="stock-adjustments"
      addBtn={false}
      showEdit={false}
      showDelete={false}
      hardcodedFilters={branchFilter}
      renderFilters={() => <ReportBranchFilter sx={{ mb: 0 }} />}
    />
  )
}
